import { render, staticRenderFns } from "./ClaimSACClaims.vue?vue&type=template&id=3f11eab8&scoped=true&lang=pug"
import script from "./ClaimSACClaims.vue?vue&type=script&lang=js"
export * from "./ClaimSACClaims.vue?vue&type=script&lang=js"
import style0 from "./ClaimSACClaims.vue?vue&type=style&index=0&id=3f11eab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f11eab8",
  null
  
)

export default component.exports